"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Tab_1 = __importDefault(require("react-bootstrap/Tab"));
var Tabs_1 = __importDefault(require("react-bootstrap/Tabs"));
var classMap_1 = __importDefault(require("../../shared/utilities/classMap"));
require("./tabs.scss");
// TODO: Convert to advanced react-bootstrap tabs using the TabContainer component
function Tabs(props) {
    var _a;
    var defaultTabSelect = function (tab) { };
    var activeTabKey = props.items[0].eventKey;
    return (react_1.default.createElement(Tabs_1.default, { id: props.tabsId,
        activeKey: props.activeKey,
        onSelect: (_a = props.onTabSelect) !== null && _a !== void 0 ? _a : defaultTabSelect,
        defaultActiveKey: activeTabKey,
        className: (0, classMap_1.default)("mpng-ux-tabs", props.className),
        role: "tablist" }, props.items.map(function (child, key) { return (react_1.default.createElement(Tab_1.default, __assign({}, child, { key: key, className: (0, classMap_1.default)("mpng-ux-tab", child.className) }), child.content)); })));
}
exports.default = Tabs;
